import { Component, OnInit } from '@angular/core';
import { DatePickerController } from './date-picker.service';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: [ './date-picker.component.scss' ]
})
export class DatePickerComponent implements OnInit {

    week = [ 0, 1, 2, 3, 4, 5 ];
    days = [ 0, 1, 2, 3, 4, 5, 6 ];
    day_names = [ 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС' ];
    month_names = [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ];

    hours: number = 0;
    minutes: number = 0;
    seconds: number = 0;
    utc: number = 0;

    current_day;
    current_month;

    private date;


    constructor(public datePickerCtrl: DatePickerController) {
    }

    ngOnInit(): void {
        this.date = new Date();
        this.setMonth(this.date.getMonth());
    }

    setMonth(month) {
        this.date = new Date();
        this.date.setMonth(month, 1);

        let day = this.date.getDay();
        this.date.setDate(2 - day);

        this.current_day = new Date().getDate();
        this.current_month = new Date().getMonth();

        this.utc = new Date().getTimezoneOffset() / 60;
    }

    hide() {
        this.datePickerCtrl.active = false;
    }

    getDate(i) {
        let d = new Date(this.date);
        d.setDate(this.date.getDate() + i);
        return { day: d.getDate(), month: d.getMonth() };
    }

    click(i) {
        let date = new Date(this.date);
        date.setDate(this.date.getDate() + i);

        let YYYY = date.getFullYear();
        let m = date.getMonth() + 1;
        let MM = m < 10 ? '0' + m : m;
        let d = date.getDate();
        let DD = d < 10 ? '0' + d : d;

        let hh = this.hours < 10 ? '0' + this.hours : this.hours;
        let mm = this.minutes < 10 ? '0' + this.minutes : this.minutes;
        let ss = this.seconds < 10 ? '0' + this.seconds : this.seconds;

        this.datePickerCtrl.emitter.emit(YYYY + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss);
        // this.hide();
    }

    clickHours(offset) {
        this.hours += offset + 24;
        this.hours %= 24;
    }

    clickMinutes(offset) {
        this.minutes += offset + 60;
        this.minutes %= 60;
    }

    clickSeconds(offset) {
        this.seconds += offset + 60;
        this.seconds %= 60;
    }

    clickUTC(offset) {
        this.utc += offset + 12;
        this.utc %= 12;
    }

    onWheelTime(event, index) {
        let delta = event.deltaY < 0 ? 1 : -1;

        if (index == 'h') this.clickHours(delta);
        if (index == 'm') this.clickMinutes(delta);
        if (index == 's') this.clickSeconds(delta);
        if (index == 'utc') this.clickUTC(delta);
    }
}
